import type { DraftReturnShipment } from "./draft-return";

export type DraftReturnCarrierCollection = NonNullable<
  DraftReturnShipment["carrierCollection"]
>;

/**
 * The collection a draft return's shipments offer. A return with any
 * collection shipment is collected as a whole; v1 has no mixed returns.
 */
export function getDraftReturnCarrierCollection(
  shipments:
    | readonly Pick<DraftReturnShipment, "carrierCollection">[]
    | null
    | undefined,
): DraftReturnCarrierCollection | undefined {
  return (
    shipments?.find((shipment) => shipment.carrierCollection)
      ?.carrierCollection ?? undefined
  );
}

/** Some shipments collected and some not; v1 can't book that as one return. */
export function isMixedCollectionReturn(
  shipments:
    | readonly Pick<DraftReturnShipment, "carrierCollection">[]
    | null
    | undefined,
): boolean {
  return (
    !!getDraftReturnCarrierCollection(shipments) &&
    !!shipments?.some((shipment) => !shipment.carrierCollection)
  );
}
